module.exports = {
  label: {
    filter: 'Filter',
    idNumberOfPatient: 'Id Number of Patient',
    patientName: 'Name of Patient',
    dob:'Date Of Birth',
    selectName:'Select Patient',
    dateFrom: 'Date From',
    dateTo: 'Date To',
    status: 'Status',
    date: 'Date',
    scriptId: 'Script ID',
    nodata:'----',
    noDataFound:'No Data Found',
    error:'Something Went Wrong',
    receivedDate:'Received Date',
    sentDate:'Sent Date',
    scriptRequestStatus:'Script Request Status',
     rejected:'REJECTED',
    placeholder: {
      enterName: 'Enter Name',
      enterIdNumber: 'Enter Id Number',
      date: "DD/MM/YY",
    },
    buttons: {
      createScript: 'Create a Script',
      filter: 'Filter',
      reset: 'Reset'
    }
  }
};